export const EVENT_STATISTICS_POLLING_INTERVAL = 2000

export const MAX_SCORES_STATISTICS = 21

export const MIN_SCORES_STATISTICS = 3

export const MAX_LENGTH_NAME_COMPETITORS = 40
